(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('somnia-global-countdown')) {
    class SomniaGlobalCountdown extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.finished = false;
        this.hidden = false;

        this.duration =
          Math.max(1, Number(this.dataset.hours) || 16) *
          60 * 60 * 1000;

        const startValue = (this.dataset.start || '').trim();

        const validFormat =
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;

        this.startTime = validFormat.test(startValue)
          ? Date.parse(startValue)
          : NaN;

        this.repeat = this.dataset.repeat === 'true';
        this.fixed = this.dataset.fixed === 'true';

        this.hoursElement = this.querySelector('[data-hours]');
        this.minutesElement = this.querySelector('[data-minutes]');
        this.secondsElement = this.querySelector('[data-seconds]');

        this.copyElement = this.querySelector('[data-countdown-copy]');
        this.timerElement = this.querySelector('[data-countdown-timer]');
        this.pendingElement = this.querySelector('[data-pending-message]');
        this.expiredElement = this.querySelector('[data-expired-message]');
        this.errorElement = this.querySelector('[data-error-message]');

        if (this.fixed) {
          this.createSpacer();
        }

        if (!Number.isFinite(this.startTime)) {
          this.setView('error');
          this.updateSpacer();
          return;
        }

        this.onVisibilityChange = () => this.update();
        this.onPageShow = () => this.update();

        document.addEventListener(
          'visibilitychange',
          this.onVisibilityChange
        );

        window.addEventListener('pageshow', this.onPageShow);

        this.update();

        if (!this.finished) {
          this.interval = window.setInterval(() => {
            this.update();
          }, 1000);
        }
      }

      createSpacer() {
        this.sectionElement = this.closest('.shopify-section');

        this.spacer = document.createElement('div');
        this.spacer.setAttribute('aria-hidden', 'true');
        this.spacer.style.pointerEvents = 'none';

        if (this.sectionElement) {
          this.sectionElement.after(this.spacer);
        } else {
          this.after(this.spacer);
        }

        this.onResize = () => this.updateSpacer();
        window.addEventListener('resize', this.onResize);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            this.updateSpacer();
          });

          this.resizeObserver.observe(this);
        }

        this.updateSpacer();
      }

      setView(view) {
        // El texto principal permanece visible mientras se espera el inicio.
        this.copyElement.hidden =
          view !== 'running' && view !== 'pending';

        this.timerElement.hidden = view !== 'running';
        this.pendingElement.hidden = view !== 'pending';
        this.expiredElement.hidden = view !== 'expired';
        this.errorElement.hidden = view !== 'error';
      }

      update() {
        const now = Date.now();

        if (now < this.startTime) {
          this.hidden = false;
          this.setView('pending');
          this.updateSpacer();
          return;
        }

        let remaining;

        if (this.repeat) {
          const elapsed = now - this.startTime;
          const elapsedInCycle = elapsed % this.duration;

          remaining = this.duration - elapsedInCycle;
        } else {
          remaining = this.startTime + this.duration - now;

          if (remaining <= 0) {
            this.renderTime(0);
            this.finish();
            return;
          }
        }

        this.hidden = false;
        this.setView('running');
        this.renderTime(remaining);
        this.updateSpacer();
      }

      renderTime(milliseconds) {
        const totalSeconds = Math.max(
          0,
          Math.ceil(milliseconds / 1000)
        );

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.hoursElement.textContent =
          String(hours).padStart(2, '0');

        this.minutesElement.textContent =
          String(minutes).padStart(2, '0');

        this.secondsElement.textContent =
          String(seconds).padStart(2, '0');
      }

      finish() {
        this.finished = true;
        window.clearInterval(this.interval);

        if (this.dataset.expiryAction === 'hide') {
          this.hidden = true;
        } else {
          this.setView('expired');
        }

        this.updateSpacer();
      }

      updateSpacer() {
        if (!this.spacer) return;

        this.spacer.style.height = this.hidden
          ? '0px'
          : `${this.getBoundingClientRect().height}px`;
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);

        if (this.onVisibilityChange) {
          document.removeEventListener(
            'visibilitychange',
            this.onVisibilityChange
          );
        }

        if (this.onPageShow) {
          window.removeEventListener(
            'pageshow',
            this.onPageShow
          );
        }

        if (this.onResize) {
          window.removeEventListener(
            'resize',
            this.onResize
          );
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.spacer) {
          this.spacer.remove();
        }

        this.initialized = false;
        this.finished = false;
      }
    }

    customElements.define(
      'somnia-global-countdown',
      SomniaGlobalCountdown
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
